import { useEffect, useState } from "react";

const info = {
  name: "Cherubini Franco",
  role: "Software Developer",
};

const defaultLinks = [
  { name: "About", url: "/#about" },
  { name: "Experience", url: "/#experience" },
  { name: "Projects", url: "/#projects" },
];

export default function Navbar({ links = defaultLinks }) {
  const [open, setOpen] = useState(false);

  useEffect(() => {
    document.body.style.overflow = open ? "hidden" : "";

    return () => {
      document.body.style.overflow = "";
    };
  }, [open]);

  const closeMenu = () => setOpen(false);

  return (
    <header>
      <nav className="fixed inset-x-0 top-0 z-50 hidden sm:block">
        <div className="mx-auto flex max-w-6xl items-center justify-between px-6 py-5">
          <a
            href="/"
            className="group flex items-center gap-3"
            aria-label={`${info.name} home`}
          >
            <div className="flex h-9 w-9 items-center justify-center overflow-hidden rounded-full bg-white/5 ring-1 ring-white/10 transition group-hover:ring-white/20">
              <img
                src="../assets/logo.png"
                alt=""
                className="h-7 w-7 object-contain"
              />
            </div>

            <div className="leading-none">
              <p className="text-sm font-medium tracking-tight text-white">
                {info.name}
              </p>
              <p className="mt-1 text-[11px] text-white/40">{info.role}</p>
            </div>
          </a>

          <div className="absolute left-1/2 -translate-x-1/2">
            <div className="flex items-center rounded-full border border-white/10 bg-white/[0.04] p-1 shadow-2xl shadow-black/10 backdrop-blur-xl">
              {links.map((link) => (
                <a
                  key={link.name}
                  href={link.url}
                  className="rounded-full px-4 py-2 text-[13px] font-medium text-white/55 transition-all duration-200 hover:bg-white/[0.07] hover:text-white"
                >
                  {link.name}
                </a>
              ))}
            </div>
          </div>

          <a
            href="#contact"
            className="group flex items-center gap-2 rounded-full border border-white/10 bg-white text-sm font-medium text-[#0B0F19] px-4 py-2 transition-all duration-200 hover:bg-white/90"
          >
            Let's talk
            <span className="transition-transform duration-200 group-hover:translate-x-0.5">
              ↗
            </span>
          </a>
        </div>
      </nav>

      <nav className="fixed inset-x-0 top-0 z-50 sm:hidden">
        <div className="flex items-center justify-between px-5 py-4">
          <a
            href="/"
            onClick={closeMenu}
            className="flex items-center gap-3"
            aria-label={`${info.name} home`}
          >
            <div className="flex h-9 w-9 items-center justify-center overflow-hidden rounded-full bg-white/5 ring-1 ring-white/10">
              <img
                src="../assets/logo.png"
                alt=""
                className="h-7 w-7 object-contain"
              />
            </div>

            <span className="text-sm font-medium text-white">{info.name}</span>
          </a>

          <button
            type="button"
            onClick={() => setOpen((value) => !value)}
            aria-label={open ? "Close menu" : "Open menu"}
            aria-expanded={open}
            className="relative flex h-10 w-10 items-center justify-center rounded-full border border-white/10 bg-white/[0.04] backdrop-blur-xl transition hover:bg-white/[0.08]"
          >
            <span className="sr-only">{open ? "Close menu" : "Open menu"}</span>

            <span
              className={`absolute h-px w-4 bg-white transition-transform duration-200 ${
                open ? "rotate-45" : "-translate-y-1"
              }`}
            />

            <span
              className={`absolute h-px w-4 bg-white transition-opacity duration-200 ${
                open ? "opacity-0" : "opacity-100"
              }`}
            />

            <span
              className={`absolute h-px w-4 bg-white transition-transform duration-200 ${
                open ? "-rotate-45" : "translate-y-1"
              }`}
            />
          </button>
        </div>
      </nav>

      {/* Mobile menu */}
      <div
        className={`fixed inset-0 z-40 bg-[#0B0F19] transition-all duration-300 sm:hidden ${
          open
            ? "pointer-events-auto opacity-100"
            : "pointer-events-none opacity-0"
        }`}
      >
        <div className="flex h-full flex-col justify-between px-6 pb-10 pt-28">
          <div>
            <div className="flex flex-col">
              {links.map((link, index) => (
                <a
                  key={link.name}
                  href={link.url}
                  onClick={closeMenu}
                  className="group flex items-center justify-between border-b border-white/[0.08] py-5 text-3xl font-medium tracking-tight text-white/70 transition hover:text-white"
                >
                  <span>{link.name}</span>

                  <span className="text-xl text-white/20 transition-all group-hover:translate-x-1 group-hover:text-white/60">
                    ↗
                  </span>
                </a>
              ))}
            </div>
          </div>

          <div>
            <a
              href="#contact"
              onClick={closeMenu}
              className="flex w-full items-center justify-between rounded-2xl bg-white px-5 py-4 text-sm font-medium text-[#0B0F19] transition hover:bg-white/90"
            >
              <span>Let's talk</span>
              <span>↗</span>
            </a>

            <p className="mt-5 text-center text-xs text-white/25">
              {info.name} · {info.role}
            </p>
          </div>
        </div>
      </div>
    </header>
  );
}
